// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"w3-z","dimensionLabel":"x3-z","styleChooserControlWrapper":"y3-z","styleChooserControl":"z3-z","disabled":"A3-z","giftCard":"B3-z","styleChooserText":"C3-z"};